import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=20a389ce&scoped=true"
import script from "./Table.vue?vue&type=script&lang=js"
export * from "./Table.vue?vue&type=script&lang=js"
import style0 from "./Table.vue?vue&type=style&index=0&id=20a389ce&prod&lang=scss&scoped=true"
import style1 from "./Table.vue?vue&type=style&index=1&id=20a389ce&prod&lang=css"
import style2 from "spinkit/scss/spinkit.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a389ce",
  null
  
)

export default component.exports